/**
 * Created by Fedor on 09.10.2026
 */

class BgRectComponent extends BaseComponent {
    onAttach() {
        this.onResize();
    }

    onResize() {
        const bgRect = cleverapps.resolution.getBgRect();

        this.node.setContentSize(bgRect.width, bgRect.height);
        this.node.setPosition(bgRect.x + bgRect.width / 2, bgRect.y + bgRect.height / 2);
    }
}

Prefab.registerComponent("BgRectComponent", BgRectComponent);
